module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av100-c5b6e9461415a8e7eb4bdfff21ad08a3.jpg";